<script setup lang="ts">
import FileList from "@/components/files/FileList.vue";
import DropButton from "@/components/DropButton.vue";
import { useFilesStore } from "@/stores/files";
import { computed } from "vue";
import FinalizeButton from "./FinalizeButton.vue";
import Header from "./Header.vue";
const fileStore = useFilesStore();

const isFinalizing = computed(() => fileStore.status.isFinalizing);
</script>

<template>
    <section class="uploading text-main" :data-finalizing="isFinalizing">
        <div class="uploading__container">
            <Header class="uploading__header" />
            <div class="uploading__step-block uploading__body">
                <div class="uploading__step-container">
                    <div class="uploading__step-title">
                        <span class="uploading__step-circle">1</span>
                        <span class="uploading__step-title">
                            Click <DropButton /> to select files <span data-nosmall>or drag & drop below</span>
                        </span>
                    </div>
                    <!-- <span class="uploading__step-right">You added {{ fileStore.fullFiles.length }} files</span>   / -->
                </div>
                <FileList class="uploading__file-list" />
            </div>
            <div class="uploading__step-block">
                <div class="uploading__step-container">
                    <span class="uploading__step-circle">2</span>
                    <span class="uploading__step-title" data-nosmall
                        >Check uploaded files and click finalise to finish session</span
                    >
                    <span class="uploading__step-right"> <FinalizeButton /></span>
                </div>
            </div>
        </div>
    </section>
</template>

<style scoped lang="scss">
.uploading {
    display: flex;
    flex-direction: row;
    place-content: center;

    width: 100%;
    height: 100%;
    background-color: #ffffff;
    position: relative;

    &[data-finalizing="true"] {
        pointer-events: none;
        opacity: 0.5;
    }

    &__id {
        position: absolute;
        right: 0;
        bottom: 0;
        padding: 10px;

        font-size: 14px;
        text-transform: uppercase;
        font-family: monospace;
    }

    &__container {
        display: flex;
        flex-direction: column;
        width: 100%;
        height: 100%;
        max-width: 800px;
        padding: 10px;
        position: relative;
    }

    &__body {
        flex: 1;
    }

    &__header {
        padding: 50px 0;
    }

    &__step-block {
        display: flex;
        flex-direction: column;
        gap: 20px;
        padding: 10px;
        align-items: center;
    }

    &__step-circle {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 40px;
        height: 40px;
        border-radius: 50%;
        border: 1px solid #000000;
        font-size: 20px;
        line-height: 14px;

        position: static;
        left: -30px;
        @media (min-width: 1000px) {
            & {
                position: absolute;
            }
        }
    }

    &__step-container {
        display: flex;
        flex-wrap: wrap;
        gap: 10px;
        width: 100%;
        align-items: center;
        font-size: 14px;
    }

    &__step-title {
        flex: 1;
        font-size: 16px;
        display: flex;
        align-items: center;
        gap: 10px;
        text-wrap: nowrap;
    }

    &__file-list {
        width: 100%;
        height: 100%;
        overflow: auto;
    }
    &__step-right {
        display: flex;
        justify-content: flex-end;
        flex: 1;
        text-wrap: nowrap;
    }

    @media screen and (max-width: 500px) {
        [data-nosmall] {
            display: none;
        }
    }
}
</style>
